import { FatInvestorsPageListEntitiesQuery } from '@/__generated__/graphql';
import FormattingTooltip from '@/components/basicComponents/tooltip/dollarsTooltip';
import { MobileRow, MobileRowTitle, MobileRowValue, MobileTableRowWrap } from '@/components/table/mobileTable/mobileTable';
import { TableColumns } from '@/components/table/types';
import styled from 'styled-components';

interface EntityMobileSumFooterProps {
  columns: TableColumns[];
  totals: FatInvestorsPageListEntitiesQuery['listEntities']['totals'];
}

const EntityMobileSumFooter = ({ columns, totals }: EntityMobileSumFooterProps) => {
  return (
    <MobileSumFooterWrap>
      <MobileRow>
        <MobileRowTitle>Total</MobileRowTitle>
      </MobileRow>

      <MobileRow>
        <MobileRowTitle>{columns[3].title}</MobileRowTitle>
        <MobileRowValue>
          <FormattingTooltip>{totals?.investmentCount}</FormattingTooltip>
        </MobileRowValue>
      </MobileRow>

      <MobileRow>
        <MobileRowTitle>{columns[4].title}</MobileRowTitle>
        <MobileRowValue>
          <FormattingTooltip>{totals?.totalValue}</FormattingTooltip>
        </MobileRowValue>
      </MobileRow>

      <MobileRow>
        <MobileRowTitle>{columns[5].title}</MobileRowTitle>
        <MobileRowValue>
          <FormattingTooltip>{totals?.totalCommitments}</FormattingTooltip>
        </MobileRowValue>
      </MobileRow>
    </MobileSumFooterWrap>
  );
};

export default EntityMobileSumFooter;

const MobileSumFooterWrap = styled(MobileTableRowWrap)`
  background-color: ${({ theme }) => theme.layer[2]};
`;
